<template>
  <div class="layout">
    <vue-modaltor
      :visible="openLogin"
      @hide="hideModal"
      :default-width="'30%'"
      :bg-overlay="'rgba(0, 0, 0, 0.7)'"
      :resize-width="{1200:'60',992:'80%',768:'90%'}"
    >
      <app-login />
    </vue-modaltor>
    <vue-modaltor
      :visible="openVideo"
      @hide="hideVideo"
      :default-width="'90%'"
      :bg-overlay="'rgba(0, 0, 0, 0.7)'"
      :resize-width="{1200:'60',992:'80%',768:'90%'}"
    >
      <!-- <b-progress v-if="isBanner" :value="progress" class="w-100" height="4px"></b-progress> -->
      <!-- <div class="video-banner-image" v-if="isBanner">
        <span
          class="video-banner"
          :style="{ backgroundImage: `url('/static/img/New-Year-98-2.jpg')` }"
        ></span>
      </div>-->
      <video
        @contextmenu.prevent
        controlslist="nodownload"
        width="100%"
        :height="height - 300 + 'px'"
        controls
        v-if="openVideo && srcVideo"
      >
        <source :src="srcVideo" type="video/mp4" />
        <!--Your browser does not support the video tag.-->
      </video>
      <video v-if="openVideo && !srcVideo " id="video" width="100%" controls autoplay></video>
    </vue-modaltor>
    <!-- basket -->
    <modal-bill :show="isPayment" @hiddenModal="hidePayment"/>
    <div class="el1full">
      <!-- v-bar -->
      <div class="el2full">
        <!-- ref="scrollingElement" -->
        <app-navbar />
        <div class="main-layout">
          <router-view></router-view>
        </div>
        <app-footer />
      </div>
    </div>
  </div>
</template>
<script>
import navbar from "~/components/navbar.vue";
import footer from "~/components/footer.vue";
import login from "~/components/login.vue";
import ModalBill from "../components/min-component/modal-bill";

var vm;
export default {
  layout: "default",
  components: {
    ModalBill,
    "app-navbar": navbar,
    "app-footer": footer,
    "app-login": login
  },
  data() {
    return {
      description: "مادیا یک پلتفرم آموزشی برای یادگیری و آموزش آنلاین می باشد که در آن مخاطبین مهارت های جدیدی را جهت دستیابی به اهداف خود با استفاده از کاملترین دوره های های آموزشی تدریس شده توسط بهترین مدرسین به دست می‌آورند. هدف مادیا، ارتقای سطح کیفیت زندگی و فضای کسب دانش و کار, از طریق آموزش‌های آنلاین می‌باشد.",      progress: 0,
      isBanner: true,
      isClicked: false,
      isLoading: false,
      defaultHeight: "450px",
      open: false,
      style: {},
      windowHeight: 0,
      screenHeight: window.screen.height - 400,
      height: window.screen.height
    };
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight > this.screenHeight) return;
      this.style = {
        "min-height": this.windowHeight - 70 + "px"
      };
    }
    // openVideo(val) {
    //   if (val) {
    //     this.progressStart()
    //     setTimeout(() => {
    //       this.isBanner = false
    //     }, 6000);
    //   } else {
    //     this.isBanner = true
    //   }
    // }
  },
    // script: [
    //   {
    //     innerHTML: JSON.stringify(this.structuredData),
    //     type: "application/ld+json"
    //   }
    // ],
  metaInfo() {
    return {
      __dangerouslyDisableSanitizers: ["script"],
      title: 'Madya Online Courses | آموزش های آنلاین مادیا',
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "مادیا یک پلتفرم آموزشی برای یادگیری و آموزش آنلاین می باشد که در آن مخاطبین مهارت های جدیدی را جهت دستیابی به اهداف خود با استفاده از کاملترین دوره های های آموزشی تدریس شده توسط بهترین مدرسین به دست می‌آورند. هدف مادیا، ارتقای سطح کیفیت زندگی و فضای کسب دانش و کار, از طریق آموزش‌های آنلاین می‌باشد."
        },
        {
          hid: "og-site_name",
          property: "og:site_name",
          content: "مادیا"
        },
        {
          hid: "og-title",
          property: "og:title",
          content: 'Madya Online Courses | آموزش های آنلاین مادیا'
        },
        {
          hid: "og-description",
          property: "og:description",
          content: this.splitString(this.description, 155)
        },
        {
          hid: "og-image",
          property: "og:image",
          content: this.pathSite + "/images/logo-invert.png"
        },
        {
          hid: "og-url",
          property: "og:url",
          content: 'https://www.madya.ir/' + this.fullPath
        },
        {
          property: "og:image",
          content:'/favicon/favicon-32x32.png'
        }
      ]
    };
  },

  computed: {
    fullPath() {
        return this.$route.fullPath;
    },
    isPayment() {
      return this.$store.state.basket.isPayment;
    },
    openLogin() {
      return this.$store.state.auth.showLogin;
    },
    openVideo() {
      return this.$store.state.video.show;
    },
    isShow() {
      return this.$store.state.basket.show;
    },
    priceOffer() {
      return this.$store.state.basket.priceOffer;
    },
    srcVideo() {
      return this.$store.state.video.src;
    }
  },
  mounted() {
    vm = this;
    this.$nextTick(function() {
      window.addEventListener("resize", function(e) {
        vm.windowHeight = window.innerHeight;
      });
    });
    this.style = {
      height: "100%"
    };
  },
  methods: {
    progressStart() {
      let inter = setInterval(() => {
        this.progress += 1;
      }, 30);
      if (this.progress === 100) {
        clearInterval(inter);
      }
    },
    hidePayment() {
      this.$store.commit("basket/SET_DATA", { data: false, id: "isPayment" });
    },
    hideModal() {
      this.$store.dispatch("auth/showModalLogin", false);
    },
    hideVideo() {
      this.$store.dispatch("video/toggleShow", { value: false });
    }
  }
};
</script>
<style lang="less">
@import (reference) "../assets/css/variable.less";

body {
  margin: 0;
  padding: 0;
}

.main-layout {
  .box-clear;
  padding-top: 60px;
  min-height: 100vh;
}
#video {
  width: 100%;
  height: 100vh;
  margin: 0 auto;
}
.box-pay{
  img{
    transition: all 0.3s ease-in;
  }
  img:hover{
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.4) !important;
  }
}
.pointer-null {
  cursor: not-allowed;
}
.video-banner-image {
  display: block;
  width: 60%;
  padding-bottom: 46%;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
}
.video-banner {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-position: 50%;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/layouts/default.vue